import { Box, Typography } from "@mui/material";
import { FC, Fragment } from "react";
import AutoComplete from "./AutoComplete";

// component interface
interface IAutoCompleteMain {
  fieldLabel?: string;
  fieldName: string;
  onChangeFn?: any;
  placeholder: string;
  keys: string;
  options: any[];
  rules?: any;
  menuLabel: string;
  readonly?: boolean;
  isRequired?: boolean;
  width?: string;
  errorsMessage?: any;
  extras?: string;
  value: any;
  defaultValue?: any;
  disabled?: boolean;
  error?: any;
  getOptionDisabled?: any;
}

const WithOutFormAutoComplete: FC<IAutoCompleteMain> = ({
  menuLabel,
  fieldLabel,
  fieldName,
  placeholder,
  onChangeFn,
  keys,
  rules,
  options,
  readonly,
  isRequired,
  width,
  errorsMessage,
  extras,
  defaultValue,
  value,
  disabled,
  error,
  getOptionDisabled,
  ...rest
}): JSX.Element => {
  return (
    <Fragment>
      {fieldLabel ? (
        <Typography className="formLabel">
          {fieldLabel}
          {isRequired ? <span style={{ color: "red" }}>*</span> : <></>}
        </Typography>
      ) : (
        <></>
      )}

      <AutoComplete
        hasInfo={false}
        getOptionDisabled={getOptionDisabled}
        style={{
          border: error ? "1px solid red" : "1px solid #e2e8f0",

          borderRadius: "0.375rem",
          width: "100%",
        }}
        extras={extras}
        width={width}
        option={options}
        readOnly={readonly ? readonly : false}
        disable={disabled}
        keys={keys}
        label={menuLabel}
        onChange={(value: any) => {
          !!onChangeFn && onChangeFn(value);
        }}
        placeholder={placeholder}
        value={!!value ? value : ""}
        {...rest}
      />
    </Fragment>
  );
};

export default WithOutFormAutoComplete;
